import { getRequest, postRequest, putRequest, deleteRequest } from './index';


// `month` is 0-based (JS Date / calendar UI); the API expects 1-12.

export const getWellnessEntries = async (month, year) => {
   return getRequest(`/wellness/entries?month=${month + 1}&year=${year}`);
};

export const getWellnessEntryByDate = async date => {
   const entries = await getRequest(`/wellness/entries/date/${date}`);
   // Backend returns array, frontend expects single entry
   return entries && entries.length > 0 ? entries[0] : null;
};

export const getWellnessEntryById = async id => {
   return getRequest(`/wellness/entries/${id}`);
};

export const createWellnessEntry = async data => {
   return postRequest('/wellness/entries', data);
};

export const updateWellnessEntry = async (id, data) => {
   return putRequest(`/wellness/entries/${id}`, data);
};

export const deleteWellnessEntry = async id => {
   return deleteRequest(`/wellness/entries/${id}`);
};
